import type { SelectOption } from '@/components/SearchableSelect'

export type ReportMonthDirection = 'prev' | 'next'

function sortedReportMonthIds(options: SelectOption[]): string[] {
  const ids = options.map((option) => option.id).filter((id): id is string => Boolean(id))
  return [...new Set(ids)].sort()
}

/** Chronological prev/next among available YYYY-MM option ids (skips calendar gaps). */
export function adjacentReportMonthId(
  options: SelectOption[],
  value: string | null | undefined,
  direction: ReportMonthDirection,
): string | null {
  if (!value || !options.length) {
    return null
  }

  const sorted = sortedReportMonthIds(options)
  const index = sorted.indexOf(value)
  if (index === -1) {
    return null
  }

  if (direction === 'prev') {
    return index > 0 ? sorted[index - 1]! : null
  }

  return index < sorted.length - 1 ? sorted[index + 1]! : null
}
